import 'Styles/header.scss';

import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import { push, goBack } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import decode from 'Utils/entities';
import rawToReact from 'Utils/bbcode/RawToReact';
import { parsePath } from 'Utils/nav/NavHelpers';

import headerSelector from 'Selectors/headerSelector';

import {
	resetOverlay, sidebarOn, sidebarOff, toggleSearchBar,
	toggleHeaderOverflow, showReplyModal,
	showConfirmModal, showShareModal, displayNotification
} from 'Actions/UiActions';
import { resetSelectedItem } from 'Actions/MetaActions';
import { trackGAEvent } from 'Actions/adsActions';
import {
	canCreateThread, canReplyThread, canEditPost,
	canOpenCloseThread, canReportPost,
	canDeletePosts, selectedPMsUnread, messageTo,
	getPmFolders, getUserInfo, currentUser
} from 'Actions/ContextInfoActions';
import { deletePosts, reportPost, markAsRead } from 'Actions/ThreadviewActions';
import { deletePms, markAsReadPM, movePMs } from 'Actions/MessagesviewActions';
import { openCloseThread } from 'Actions/ModToolsActions';

import SvgIcon from 'Components/svg/SvgIcon';
import LoadingComponent from 'Components/header/LoadingComponent';

class HeaderComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.selectedItems = 0;
		this.rightIcons = new Map();
		this.prevRightIcons = [];
		this.showOverfloMenu = true;
		this.currentPath = [];
		this.iconsMustUpdate = true;
	}

	componentDidMount() {
		this.currentPath = parsePath( this.props.routing.locationBeforeTransitions.pathname );
	}

	shouldComponentUpdate( nextProps ) {
		this.iconsMustUpdate = (
			this.selectedItems !== Object.keys( nextProps.selectedElements ).length ||
			!isEqual( nextProps.userPermissions, this.props.userPermissions ) ||
			this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname ||
			this.props.isLoading !== nextProps.isLoading ||
			this.props.isFetchingAny !== nextProps.isFetchingAny
		);

		return (
			this.props.title !== nextProps.title ||
			this.props.subTitle !== nextProps.subTitle ||
			this.iconsMustUpdate
		);
	}

	componentWillUpdate( nextProps ) {
		this.selectedItems = Object.keys( nextProps.selectedElements ).length;

		if(
			this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname
		) {
			this.rightIcons.clear(); // reset previous options
			this.currentPath = parsePath( nextProps.routing.locationBeforeTransitions.pathname );
		}
	}

	/* Event handlers */
	handleHamburgerClick = () => {
		if( this.props.ui.sidebarOpened ) {
			this.props.dispatch( goBack() );
			this.props.dispatch( sidebarOff() );
		} else {
			this.props.dispatch( sidebarOn() );
		}
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'sideMenu', 'uiAction', 'header' ) );
	};

	handleSearchBarClick = () => {
		this.props.dispatch( toggleSearchBar() );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'searchBar', 'uiAction', 'header' ) );
	};

	handleMoreActionsClick = () => {
		this.props.dispatch( toggleHeaderOverflow() );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'overflowMenu', 'uiAction', 'header' ) );
	};

	replyTo = ( event ) => {
		let options = {
				type: event.currentTarget.dataset.type,
				id: this.currentPath[ 2 ]
			};

		this.props.dispatch( resetOverlay() );

		// get data we need
		if( this.currentPath.length ) {
			let userInfo = {};
			switch( this.currentPath[ 1 ] ) {
				case 'pms':
					if( options.type === 'newMessage' ) {
						delete options.id;
					}
					break;

				case 'pm':
					userInfo = this.props.dispatch( messageTo( options.id ) );
					options = { ...options, user: userInfo };
					break;

				case 'userprofile':
					userInfo = this.props.dispatch( getUserInfo( options.id ) );
					options = { ...options, user: userInfo };
					break;
			}
		}

		this.props.dispatch( showReplyModal( options ) );

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, `replyTo_${ options.type }`, 'uiAction', 'header' ) );
	};

	deleteSelectedPosts = ( event ) => {
		let type = event.currentTarget.dataset.type;

		this.props.dispatch( resetOverlay() );

		let title = `${ type === 'delete' ? `Delete` : `Restore` } Post${ this.selectedItems > 1 ? 's' : '' }`,
			question = `Are you sure you want to ${ type === 'delete' ? `delete` : `restore` } ${ this.selectedItems > 1 ? 'these ' + this.selectedItems : 'the' } selected post${ this.selectedItems > 1 ? 's' : '' }?`;
		this.props.dispatch( showConfirmModal( title, question, () => this.props.dispatch( deletePosts( Object.keys( this.props.selectedElements ), ( type === 'delete' ) ) ) ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, ( type === 'delete' ? 'deletePosts' : 'undeletePosts' ), 'uiAction', 'header' ) );
	};

	deleteSelectedPms = () => {
		let isFolder = this.currentPath[ 1 ] === 'pms',
			selectedPMs = isFolder ? Object.keys( this.props.selectedElements ) : [ this.currentPath[ 2 ] ];

		this.props.dispatch( resetOverlay() );

		let title = `Delete PM${ isFolder && this.selectedItems > 1 ? 's' : '' }`,
			question = `Are you sure you want to delete ${ isFolder && this.selectedItems > 1 ? 'these ' + this.selectedItems: 'the' } ${ !isFolder ? '' : 'selected' } Message${ isFolder && this.selectedItems > 1 ? 's' : '' }?`;
		this.props.dispatch( showConfirmModal( title, question, () => this.props.dispatch( deletePms( selectedPMs, isFolder ) ) ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'deletePM', 'uiAction', 'header' ) );
	};

	moveSelectedPms = () => {
		let selectedPMs = Object.keys( this.props.selectedElements ),
			folderList = this.props.dispatch( getPmFolders() ),
			otherFolders = Object.keys( folderList ).filter( ( f ) => folderList[ f ].movableitems && parseInt( f ) !== parseInt( this.currentPath[ 2 ] ) ),
			folderSelect = [];

		if( folderList[ this.currentPath[ 2 ] ].movableitems !== true ) {
			displayNotification( 'warning', `You cannot move messages from "${ folderList[ this.currentPath[ 2 ] ].name }" folder` );
			return;
		}

		if( otherFolders.length <= 0 ) {
			displayNotification( 'warning', 'You don\'t have messages folders' );
			return;
		}

		if( selectedPMs.length <= 0 ) {
			return;
		}

		otherFolders.map( ( fid ) => {
			let folder = folderList[ fid ],
				textOp = `${ decode( folder.name ) } ( ${ folder.count } message${ folder.count === 1 ? '' : 's' } )`,
				op = <option key={ `folder_${folder.id}` } value={ folder.id }>{ textOp }</option>;
			folderSelect.push( op );
		} );

		let title = "Move Messages",
			content = <div>
				<p>Where do you want to move { selectedPMs.length > 1 ? 'them' : 'it' }? </p>
				<div className="styled-field folderList">
					<select ref={ (f) => this.selectFolder = f } >
						{ folderSelect }
					</select>
				</div>
			</div>;

		this.props.dispatch( showConfirmModal( title, content, () => this.props.dispatch( movePMs( selectedPMs, this.selectFolder.value ) ) ) );

	};

	markPmsAsRead = ( event ) => {
		let read = event.currentTarget.dataset.type === 'read';

		this.props.dispatch( resetOverlay() );
		this.props.dispatch( markAsReadPM( Object.keys( this.props.selectedElements ), read ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'markMessageAsRead', 'uiAction', 'header', ( read ? 1 : 0 ) ) );
	};

	markThreadsAsRead = () => {
		this.props.dispatch( resetOverlay() );
		this.props.dispatch( markAsRead( Object.keys( this.props.selectedElements ), 'topics' ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'markThreadsAsRead', 'uiAction', 'header' ) );
	};

	openCloseThisThread = ( event ) => {
		let open = event.currentTarget.dataset.type === 'open',
			threadid = this.currentPath[2];

		this.props.dispatch( resetOverlay() );
		this.props.dispatch( openCloseThread( threadid, open ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'openCloseThread', 'uiAction', 'header', ( open ? 1 : 0 ) ) );
	};

	clearSelectedItems = () => {
		this.props.dispatch( resetOverlay() );
		this.props.dispatch( resetSelectedItem() );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'clearSelected', 'uiAction', 'header' ) );
	};

	navigateBack = () => {
		this.props.dispatch( goBack() );
	};

	shareLink = () => {
		this.props.dispatch( showShareModal() );
	};

	reportSelectedPost = () => {
		let title = "Reporting post",
			content = <div>
				<p>Are you sure you want to report this post?</p>
				<input id="reason" type="text" placeholder="Reason for reporting" />
			</div>;
		this.props.dispatch( showConfirmModal( title, content, () => this.props.dispatch( reportPost( Object.keys( this.props.selectedElements )[0] ) ) ) );
	};

	goToUserCP = () => {
		this.props.dispatch( push( '/usercp' ) );
	};

	/* Build icons */
	buildLeftIcons() {
		return this.selectedItems > 0 ?
			<div key="back" className="buttons" onClick={ this.clearSelectedItems }><SvgIcon icon="arrow_back" size="24px"/></div> :
			<div key="hamburger" className="buttons" onClick={ this.handleHamburgerClick }><SvgIcon icon="hamburger" size="24px"/></div>;
	}

	// Options showed here as icons should not be on the overflow menu (HeaderOverFlowComponent), le's avoid duplications
	buildRightIcons() {
		let activeIcons = {},
			options = [],
			icon = null;

		this.showOverfloMenu = true;

		// if isFetching do not change icons
		if( this.iconsMustUpdate && this.props.isLoading !== true ) {
			let path = this.currentPath[ 1 ] || this.currentPath[ 0 ];
			// Set icons defaulted to no show unless we can easily set them up.
			// WARNING! The order set here will be order shown in header so keep it
			this.rightIcons.set( 'newTopic', {
				show: false,
				className: "",
				type: "newTopic",
				onclick: this.replyTo,
				icon: 'add_circle'
			} );
			this.rightIcons.set( 'replyQuoting', {
				show: false,
				className: "",
				type: "replyQuoting",
				onclick: this.replyTo,
				icon: 'quote'
			} );
			this.rightIcons.set( 'replyToThread', {
				show: false,
				className: "",
				type: "replyPost",
				onclick: this.replyTo,
				icon: 'add_circle'
			} );
			this.rightIcons.set( 'editPost', {
				show: false,
				className: "",
				type: "editPost",
				onclick: this.replyTo,
				icon: 'edit'
			} );
			this.rightIcons.set( 'deletePosts', {
				show: false,
				className: "",
				type: 'delete',
				onclick: this.deleteSelectedPosts,
				icon: 'delete'
			} );
			this.rightIcons.set( 'unDeletePosts', {
				show: false,
				className: "",
				type: 'restore',
				onclick: this.deleteSelectedPosts,
				icon: 'restore'
			} );
			this.rightIcons.set( 'reportPost', {
				show: false,
				className: "",
				type: null,
				onclick: this.reportSelectedPost,
				icon: 'warning'
			} );
			this.rightIcons.set( 'closeThread', {
				show: false,
				className: "modTools",
				type: "close",
				onclick: this.openCloseThisThread,
				icon: 'lock_close'
			} );
			this.rightIcons.set( 'openThread', {
				show: false,
				className: "modTools",
				type: "open",
				onclick: this.openCloseThisThread,
				icon: 'lock_open'
			} );
			this.rightIcons.set( 'newMessage', {
				show: false,
				className: "",
				type: "newMessage",
				onclick: this.replyTo,
				icon: 'add_circle'
			} );
			this.rightIcons.set( 'markThreadAsRead', {
				show: false,
				className: "",
				type: "read",
				onclick: this.markThreadsAsRead,
				icon: 'mark_read'
			} );
			this.rightIcons.set( 'markPMAsRead', {
				show: false,
				className: "",
				type: "read",
				onclick: this.markPmsAsRead,
				icon: 'mark_read'
			} );
			this.rightIcons.set( 'markPMAsUnRead', {
				show: false,
				className: "",
				type: "unread",
				onclick: this.markPmsAsRead,
				icon: 'mark_unread'
			} );
			this.rightIcons.set( 'movePMs', {
				show: false,
				className: "",
				type: null,
				onclick: this.moveSelectedPms,
				icon: 'folder'
			} );
			this.rightIcons.set( 'replyMessageQuoting', {
				show: false,
				className: "",
				type: "replyMessageQuoting",
				onclick: this.replyTo,
				icon: 'quote'
			} );
			this.rightIcons.set( 'replyMessage', {
				show: false,
				className: "",
				type: "replyMessage",
				onclick: this.replyTo,
				icon: 'reply'
			} );
			this.rightIcons.set( 'deletePms', {
				show: false,
				className: "",
				type: null,
				onclick: this.deleteSelectedPms,
				icon: 'delete'
			} );
			this.rightIcons.set( 'userCP', {
				show: false,
				className: "",
				type: null,
				onclick: this.goToUserCP,
				icon: 'settings2'
			} );
			this.rightIcons.set( 'newMessageUserProfile', {
				show: false,
				className: "",
				type: "newMessage",
				onclick: this.replyTo,
				icon: 'message'
			} );
			// checkok can be set by path
			this.rightIcons.set( 'checkok', {
				show: path === 'settings',
				className: "",
				type: null,
				onclick: this.navigateBack,
				icon: 'check'
			} );
			// share can be set by path
			this.rightIcons.set( 'share', {
				show: /\//.test( path ),
				className: "",
				type: null,
				onclick: this.shareLink,
				icon: 'share'
			} );
			// search can be set by path

			// if we don't have new 'home' then we allow search on index forums = '/'
			let searchAllowedByPath = process.env.config.section.home === true ? /forums|search|topics/.test( path ) : /\/|forums|search|topics/.test( path );
			this.rightIcons.set( 'search', {
				show: this.props.userPermissions && this.props.userPermissions.search && searchAllowedByPath,
				className: "",
				type: null,
				onclick: this.handleSearchBarClick,
				icon: 'search'
			} );

			// Check icons show/hide per path
			switch( path ) {
				case 'forums':
					activeIcons.newTopic = this.props.dispatch( canCreateThread() ) && this.selectedItems <= 0;
					activeIcons.share = this.selectedItems <= 0;
					activeIcons.markThreadAsRead = this.selectedItems > 0;
					break;

				case 'topics':
					let canIReplyThread = this.props.dispatch( canReplyThread() ),
						threadOpenClosePerms = this.props.dispatch( canOpenCloseThread() );

					activeIcons.deletePosts = canIReplyThread && this.selectedItems > 0 && this.props.dispatch( canDeletePosts( false ) );
					activeIcons.unDeletePosts = canIReplyThread && this.selectedItems > 0 && this.props.dispatch( canDeletePosts( true ) );
					activeIcons.replyQuoting = activeIcons.unDeletePosts === false && canIReplyThread && this.selectedItems > 0;
					activeIcons.replyToThread = canIReplyThread;
					activeIcons.editPost = canIReplyThread && this.selectedItems === 1 && this.props.dispatch( canEditPost( Object.keys( this.props.selectedElements )[ 0 ] ) );
					activeIcons.reportPost = activeIcons.unDeletePosts === false && this.selectedItems === 1 && this.props.dispatch( canReportPost() );
					activeIcons.closeThread = threadOpenClosePerms === true && this.selectedItems === 0;
					activeIcons.openThread = threadOpenClosePerms === false && this.selectedItems === 0;
					activeIcons.share = threadOpenClosePerms !== true && this.selectedItems === 0;
					break;

				case 'pms':
					let markAsRead = this.selectedItems > 0 && this.props.dispatch( selectedPMsUnread( true ) ),
						folderList = this.selectedItems ? this.props.dispatch( getPmFolders() ) : [],
						foldersCanMove = Object.keys( folderList ).filter( ( f ) => folderList[ f ].movableitems && parseInt( f ) !== parseInt( this.currentPath[ 2 ] ) );

					activeIcons.newMessage = this.props.userPermissions && this.props.userPermissions.cansendmessages;
					activeIcons.deletePms = this.selectedItems > 0;
					activeIcons.movePMs = this.selectedItems > 0 && folderList[ this.currentPath[ 2 ] ] && folderList[ this.currentPath[ 2 ] ].movableitems && foldersCanMove.length > 0;
					activeIcons.markPMAsRead = this.selectedItems > 0 && markAsRead;
					activeIcons.markPMAsUnRead = this.selectedItems > 0 && !markAsRead;
					break;

				case 'pm':
					activeIcons.replyMessageQuoting = this.props.userPermissions && this.props.userPermissions.cansendmessages;
					activeIcons.replyMessage = this.props.userPermissions && this.props.userPermissions.cansendmessages;
					activeIcons.deletePms = true;
					break;

				case 'userprofile':
					let current_User = this.props.dispatch( currentUser() ),
						selected_user = parseInt( this.currentPath[ 2 ] );

					activeIcons.userCP = current_User.id === selected_user;
					activeIcons.newMessageUserProfile = !( parseInt( current_User.id ) === selected_user );
					break;

				case 'search':
					break;

				case 'following':
				case 'participated':
				case 'latest':
				case 'updated':
					activeIcons.markThreadAsRead = this.selectedItems > 0;
					break;

				case 'register':
					this.showOverfloMenu = false;
					break;

				case 'settings':
					this.showOverfloMenu = false;
					break;
			}

			// Create the array with the icons
			this.rightIcons.forEach( ( value, key ) => {
				if( value.show || activeIcons[ key ] === true ) {
					icon = <div key={ key } className={ `buttons ${ value.className }` } data-type={ value.type }
								onClick={ value.onclick }><SvgIcon icon={ value.icon } size="24px"/></div>;
					options.push( icon );
				}
			} );

			this.prevRightIcons = options;
		}

		return this.prevRightIcons;
	}

	getHeaderTitle() {
		let { title, subTitle } = this.props;

		let titleText = this.props.isLoading ? <LoadingComponent text="Loading" /> : rawToReact( title );

		return this.selectedItems > 0 ?
			<div className="title"><div className="titleBottom">{ this.selectedItems }</div></div> :
			<div className="title">
				<div className="titleTop">{ subTitle ? rawToReact( subTitle ) : "" }</div>
				<div className="titleBottom">{ titleText }</div>
			</div>;
	}

	render() {
		let leftIcons = this.buildLeftIcons(),
			rightIcons = this.buildRightIcons(),
			headerTitle = this.getHeaderTitle(),
			overFlowMenu = this.showOverfloMenu ? <div className="buttons" onClick={ this.handleMoreActionsClick }>
					<SvgIcon icon="more_vert" size="24px" />
				</div> : null;

		return (
			<header id="header" className="primary nolinks">
				<div className="buttons-container leftHeaderIcons">
					{ leftIcons }
				</div>
				{ headerTitle }
				<div className={ `buttons-container ${ this.props.isLoading ? 'hidden' : '' } `} >
					 { rightIcons }
				 </div>
				{ overFlowMenu }
			</header>
		);
	}
}

HeaderComponent.propTypes = {
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string
};

export default connect( headerSelector )( HeaderComponent );



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js